export default "__VITE_ASSET__iTWaElSd__ 1200w";